<template>
  <NumberFilterCommon
    :title="title"
    :value="value"
    :target="customFieldItem"
    :key-name="keyName"
    :is-display-only="isDisplayOnly"
  />
</template>

<script lang="ts" setup>
import type { TFilterParam, TPropsCommon } from '../NumberFilterCommon.vue';
import NumberFilterCommon from '../NumberFilterCommon.vue';

type TProps = TPropsCommon & {
  customFieldItem?: TFilterParam;
};
defineProps<TProps>();
</script>
